import { makeActionCreator } from "../../utils";

export const UNOFFICIAL_NAME_CHANGED = "ORDERS.UNOFFICIAL_NAME.UNOFFICIAL_NAME_CHANGED";

export const unofficialNameChanged = makeActionCreator(UNOFFICIAL_NAME_CHANGED, "payload");
